module.exports = __webpack_public_path__ + "img/watermelon-slice.0ee16dd5.svg";